export function unconfiguredEbookForm($, document, $ajax) {
    const ebookForms = document.getElementsByClassName('eBookForm');
    const emailInputFields = document.querySelectorAll('.emailInputField');

    $(ebookForms).on('submit', submitForm);
    emailInputFields.forEach((emailInputField) => { emailInputField.onkeydown = newsletterConsentToggle; });

    function submitForm(e) {
        e.preventDefault();
        const form = e.target;
        const url = form.getAttribute('action');
        const submitFormRequest = $ajax(url, $(form).serialize());
        const emailField = form.querySelector('.emailInputField');

        submitFormRequest.then((response) => {
            const responseErrorMessages = form.querySelector('.ebookFormErrors');
            const responseSuccessMessages = form.querySelector('.ebookFormSuccess');
            const closeBtn = document.createElement('span');
            closeBtn.className = 'hideErrorMessage';
            responseErrorMessages.innerHTML = '';
            responseSuccessMessages.innerHTML = '';
            responseErrorMessages.appendChild(closeBtn);

            closeBtn.addEventListener('click', (event) => {
                const errorMessagesContainer = event.target.parentNode;
                errorMessagesContainer.classList.add('hide');
            });

            Object.keys(response.errors).forEach((key) => {
                const message = response.errors[key];
                const errorMessageSpan = document.createElement('span');

                errorMessageSpan.className = 'ebookError';
                errorMessageSpan.appendChild(document.createTextNode(message));

                responseErrorMessages.appendChild(errorMessageSpan);
                responseErrorMessages.appendChild(document.createElement('br'));
                responseErrorMessages.classList.remove('hide');

                emailField.classList.add('errorField');
            });

            Object.keys(response.successMessages).forEach((key) => {
                const message = response.successMessages[key];
                const node = document.createElement('span');
                node.className = 'ebookSuccess';
                node.appendChild(document.createTextNode(message));

                responseSuccessMessages.appendChild(node);
                responseSuccessMessages.appendChild(document.createElement('br'));
                responseSuccessMessages.classList.remove('hide');
            });

            setTimeout(() => {
                $(responseSuccessMessages).fadeOut(1000);
            }, 8000);
        });
    }

    function newsletterConsentToggle(e) {
        const checkBoxList = e.target.parentNode.parentNode.querySelector('.checkbox_list');

        checkBoxList.parentNode.classList.remove('hide');
        checkBoxList.querySelector('.newsleterConsentCheckBox').checked = false;

        e.target.onkeydown = null;
    }
}

const ebookForm = () => unconfiguredEbookForm.bind(null, $, document, $.post);
export { ebookForm };
